module.exports = __webpack_public_path__ + "media/images/MRM-qicon-c16560ac.png";